//* 편리정보 > 자주쓰는 상주말씀 관리 — 스펙: docs/bugo-mourner-text-favorites-spec.md
import { FC } from 'react';

import PreferMournerTextEditor from '../containers/PreferMournerTextEditor/PreferMournerTextEditor';
import { useTitleHook } from '../hooks/useTitleHook';

const PreferMournerTextPage: FC = () => {
  useTitleHook('자주쓰는 상주말씀 관리');

  return (
    <div className="space-y-4 px-4 py-4 text-sm">
      <div className="space-y-3 rounded-xl px-5 py-4 theme-bg-1">
        <p className="text-xs theme-text-8">
          등록한 상주말씀은 부고 등록·수정 화면의 상주 말씀 입력 위에 바로 나타나, 누르면
          채워집니다.
        </p>
        <PreferMournerTextEditor />
      </div>
    </div>
  );
};

export default PreferMournerTextPage;
